import { Component, OnInit, ViewChild, OnDestroy, Input, Output, EventEmitter, ElementRef, Renderer2 } from '@angular/core';
import { ModalDirective } from "ngx-bootstrap/modal";
import { AbstractBaseComponent } from "../abstract-base.component";
import { ModalResult } from '..';

@Component({
    selector: 'my-message-box-modal',
    templateUrl: 'message-box-modal.component.html'
})
export class MessageBoxComponent extends AbstractBaseComponent implements OnInit, OnDestroy {

    @ViewChild('messageBoxModel', {static: true}) messageBoxModal: ModalDirective;
    @Input() displayText: string;
    @Input() modalHeader: string;
    @Input() buttonText: string ;
    @Input() hideConfirmButton: boolean = false;
    @Input() hideCancelButton: boolean = false;
    @Input() hideCloseButton: boolean = false;
    @Input() buttonTextCancel: string;
    @Output() modalClosing: EventEmitter<ModalResult> = new EventEmitter<ModalResult>();

    MyModalResult = ModalResult;

    constructor(){
        super();
    }

    ngOnInit(): void {        

        this.messageBoxModal.config={
            backdrop:'static',
            keyboard:false
        };
    }
    show(){
        this.messageBoxModal.show();
    }

    hide(){
        this.messageBoxModal.hide();
    }

    cancelModal() {
        this.hide();
        this.ngOnDestroy();
    }

    /**
     * Close the designated modal and clean up.
     * @param modal
     */
    closeModal(result: ModalResult) {
        this.modalClosing.emit(result);
        this.hide();
        this.ngOnDestroy();
    }
}